<template>
  <!-- 右侧填报区域 -->
  <div class="form-container flex-grow p-6">
      <div class="form-note">
        <div class="form-note-title">
          <i class="fas fa-info-circle"></i>填报说明
        </div>
        <div class="form-note-content">
          <ul class="list-disc pl-5 space-y-1">
            <li>请填写展览展销活动的基础信息，带 <span class="text-red-500">*</span> 的字段为必填项</li>
            <li>填写完成后点击"保存并下一步"按钮继续申报流程</li>
            <li>如有疑问，请联系客服热线：400-123-4567</li>
          </ul>
        </div>
      </div>

      <form id="basicInfoForm">
        <!-- 展会基本信息 -->
        <div class="form-section mb-8 pb-6">
          <h3 class="text-xl font-semibold mb-6 text-gray-800">一、展会基本信息</h3>

          <div class="form-row mb-4">
            <div class="form-col">
              <div class="form-group">
                <label for="exhibitionName" class="form-label required-field">展会名称</label>
                <input type="text" id="exhibitionName" name="exhibitionName" class="form-input" required>
                <div class="form-helper-text">请填写展会的正式名称</div>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="exhibitionType" class="form-label required-field">展会类型</label>
                <select id="exhibitionType" name="exhibitionType" class="form-select" required>
                  <option value="">请选择展会类型</option>
                  <option value="comprehensive">综合类展会</option>
                  <option value="professional">专业类展会</option>
                  <option value="consumer">消费类展会</option>
                  <option value="food">食品类展会</option>
                  <option value="technology">科技类展会</option>
                  <option value="other">其他类型</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-row mb-4">
            <div class="form-col">
              <div class="form-group">
                <label for="startDate" class="form-label required-field">开始日期</label>
                <input type="date" id="startDate" name="startDate" class="form-input" required>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="endDate" class="form-label required-field">结束日期</label>
                <input type="date" id="endDate" name="endDate" class="form-input" required>
              </div>
            </div>
          </div>

          <div class="form-row mb-4">
            <div class="form-col">
              <div class="form-group">
                <label for="venue" class="form-label required-field">举办地点</label>
                <input type="text" id="venue" name="venue" class="form-input" required>
                <div class="form-helper-text">请填写详细的展会地址</div>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="area" class="form-label required-field">展览面积(平方米)</label>
                <input type="number" id="area" name="area" class="form-input" min="0" step="1" required>
              </div>
            </div>
          </div>

          <div class="form-row mb-4">
            <div class="form-col">
              <div class="form-group">
                <label for="boothCount" class="form-label required-field">预计展位数量</label>
                <input type="number" id="boothCount" name="boothCount" class="form-input" min="0" step="1" required>
              </div>
            </div>
            <div class="form-col">
              <div class="form-group">
                <label for="expectedVisitors" class="form-label required-field">预计参观人数</label>
                <input type="number" id="expectedVisitors" name="expectedVisitors" class="form-input" min="0" step="1" required>
              </div>
            </div>
          </div>

          <div class="form-group mb-4">
            <label for="exhibitionTheme" class="form-label required-field">展会主题</label>
            <input type="text" id="exhibitionTheme" name="exhibitionTheme" class="form-input" required>
          </div>

          <div class="form-group mb-4">
            <label for="exhibitionDescription" class="form-label required-field">展会简介</label>
            <textarea id="exhibitionDescription" name="exhibitionDescription" class="form-textarea" rows="4" required></textarea>
            <div class="form-helper-text">请简要描述展会的目的、内容和特色</div>
          </div>
        </div>

        <!-- 表单操作按钮 -->
        <div class="form-actions">
          <button type="button" class="btn btn-outline" id="saveDraftBtn">
            <i class="fas fa-save mr-2"></i> 保存草稿
          </button>
          <button type="button" class="btn btn-secondary" id="cancelBtn">
            <i class="fas fa-times mr-2"></i> 取消
          </button>
          <button type="submit" class="btn btn-primary" id="submitBtn">
            <i class="fas fa-arrow-right mr-2"></i> 保存并下一步
          </button>
        </div>
      </form>
    </div>
</template>
<script>
export default {
  name: "StepOne",
  data() {
    return {
      step: 1,
    }
  },
  mounted() {

  },
  methods: {
    openRouter(){
      const { href } = this.$router.resolve({
        path: '/jlzc/ljbl/home',
        query:{}
      });
      window.open(href, '_blank', 'noopener');
    },
    handleAgency() {
      // “我需要代办服务” 按钮的逻辑
      // 可以跳转到客服/在线咨询/填写需求弹窗等
      alert('已收到您的代办服务需求，我们会尽快与您联系。');
    },
    stepSelected(num){
      this.step = num
    }
  }
}
</script>

<style scoped>
/* 浮动按钮样式 */
.floating-btn {
  position: fixed;
  right: 0px;
  bottom: 40%;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  background: #ff8a00;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  outline: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  z-index: 1000;
}

.floating-btn:hover {
  background: #ffa033;
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
}

.form-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.step-nav {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 1rem;
}

.step-card {
  transition: all 0.3s ease;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  border: 2px solid #e2e8f0;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.75rem;
  width: 100%;
  background-color: white;
}

.step-card:hover:not(.active):not(.completed) {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.step-card.active {
  border-color: #0ea5e9;
  background-color: #e0f2fe;
}

.step-card.completed {
  border-color: #10b981;
  background-color: #d1fae5;
}

.step-card.required {
  border-color: #f97316;
}

.step-card.required:hover:not(.active):not(.completed) {
  border-color: #fb923c;
}

.step-number {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.step-card.active .step-number {
  background-color: #0ea5e9;
  color: white;
}

.step-card.completed .step-number {
  background-color: #10b981;
  color: white;
}

.step-card:not(.active):not(.completed) .step-number {
  background-color: #e2e8f0;
  color: #64748b;
}

.step-card.required:not(.active):not(.completed) .step-number {
  background-color: #fdba74;
  color: #c2410c;
}

.step-content {
  flex: 1;
}

.step-title {
  font-weight: 500;
  color: #334155;
  font-size: 14px;
}

.step-status {
  font-size: 12px;
  color: #64748b;
  margin-top: 0.25rem;
}

.step-card.active .step-title {
  color: #0369a1;
}

.step-card.completed .step-title {
  color: #065f46;
}

.step-card.required:not(.active):not(.completed) .step-title {
  color: #c2410c;
}

.form-section {
  border-bottom: 1px solid #e2e8f0;
}

.form-section:last-child {
  border-bottom: none;
}

.form-note {
  background-color: #f0f9ff;
  border-left: 4px solid #0ea5e9;
  padding: 1rem;
  border-radius: 0 6px 6px 0;
  margin-bottom: 1.5rem;
}

.form-note-title {
  font-weight: 600;
  color: #0c4a6e;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.form-note-title i {
  margin-right: 0.5rem;
}

.form-note-content {
  color: #1e40af;
  font-size: 14px;
}

.form-label {
  display: block;
  font-weight: 500;
  color: #334155;
  margin-bottom: 0.5rem;
}

.form-input, .form-select, .form-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-input:focus, .form-select:focus, .form-textarea:focus {
  outline: none;
  border-color: #0ea5e9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);
}

.form-input:disabled, .form-select:disabled, .form-textarea:disabled {
  background-color: #f1f5f9;
  cursor: not-allowed;
}

.form-group {
  margin-bottom: 1.5rem;
}

.required-field::after {
  content: '*';
  color: #ef4444;
  margin-left: 0.25rem;
}

.form-helper-text {
  color: #64748b;
  font-size: 12px;
  margin-top: 0.25rem;
}

.form-error {
  color: #ef4444;
  font-size: 12px;
  margin-top: 0.25rem;
}

.checkbox-group, .radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.checkbox-item, .radio-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.checkbox-item input[type="checkbox"], .radio-item input[type="radio"] {
  width: auto;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.btn-primary {
  background-color: #0ea5e9;
  color: white;
}

.btn-primary:hover {
  background-color: #0284c7;
}

.btn-secondary {
  background-color: #64748b;
  color: white;
}

.btn-secondary:hover {
  background-color: #475569;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #cbd5e1;
  color: #64748b;
}

.btn-outline:hover {
  background-color: #f1f5f9;
}

.form-row {
  display: flex;
  gap: 1.5rem;
}

.form-col {
  flex: 1;
}

.file-upload {
  border: 2px dashed #cbd5e1;
  border-radius: 6px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.file-upload:hover {
  border-color: #0ea5e9;
  background-color: #f0f9ff;
}

.file-upload input[type="file"] {
  display: none;
}

.file-upload-label {
  display: block;
  cursor: pointer;
}

.file-upload-icon {
  font-size: 2rem;
  color: #94a3b8;
  margin-bottom: 0.5rem;
}

.file-upload-text {
  font-weight: 500;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.file-upload-hint {
  font-size: 12px;
  color: #94a3b8;
}

@media (max-width: 768px) {
  .step-nav {
    position: relative;
    width: 100%;
    margin-bottom: 2rem;
  }

  .step-list {
    display: flex;
    overflow-x: auto;
    padding-bottom: 1rem;
    gap: 0.75rem;
  }

  .step-card {
    min-width: 180px;
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

</style>
